import "@fancyapps/ui/dist/fancybox/fancybox.css";

import { Fancybox } from "@fancyapps/ui";

const fancyboxConfig = {
  Carousel: {
    Toolbar: {
      display: {
        left: ["counter"],
        middle: [
          "zoomIn",
          "zoomOut",
          "toggle1to1",
          "rotateCCW",
          "rotateCW",
          "flipX",
          "flipY",
        ],
        right: ["autoplay", "thumbs", "close"],
      },
    },
  },
};

export const initFancybox = (): void => {
  Fancybox.bind("[data-fancybox]", fancyboxConfig);
};

export const destroyFancybox = (): void => {
  Fancybox.destroy();
};
